import React, { Component } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Link } from "react-scroll";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircle } from "@fortawesome/free-solid-svg-icons";
import { faCircle as farCircle } from "@fortawesome/free-regular-svg-icons";
import {Animated} from "react-animated-css";

import Layout from "../components/layout";

import processPageHeader from "../../static/images/process/process-page-header.png";
import opportunity from "../../static/images/process/opportunity.svg";
import data from "../../static/images/process/data.svg";
import walk from "../../static/images/process/walk.svg";
import math from "../../static/images/process/math.svg";
import build from "../../static/images/process/build.svg";
import secure from "../../static/images/process/secure.svg";
import deploy from "../../static/images/process/deploy.svg";
import adoption from "../../static/images/process/adoption.svg";
import '../styles/style.scss';

// import product_builders from "../../static/images/process/product_builders.svg";
// import product_leaders from "../../static/images/process/product_leaders.svg";
// import product_owners from "../../static/images/process/product_owners.svg";

// import { getVisiblePercentage } from "../utilities/elementUtilities";

import { assignActiveElementNew, visibilityObject, changeSlideInClass  } from "../utilities/elementUtilities";

class Process extends Component {
  constructor(props) {
    super(props);
    this.state = {
      secure_your_investment_offset: -10,
      drive_adoption: -10,
    };
    this.changeOffset = this.changeOffset.bind(this);
  }

  componentDidMount() {
    window.addEventListener("resize", this.resizeLine);
    window.addEventListener("scroll", this.handleScroll);
    window.addEventListener("resize", this.handleScroll);
    window.addEventListener("resize", this.changeOffset);

    this.handleScroll();
    this.resizeLine();
    this.changeOffset();
  }

  changeOffset = () => {
    var width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;

    if (width <= 991) {
      this.setState({ 
        secure_your_investment_offset: 70,
        drive_adoption: 50
      });
    } else {
      this.setState({ 
        secure_your_investment_offset: -10,
        drive_adoption: -10
      });
    }
  } 

  handleScroll = () => {

    var ensure_your_succcess = visibilityObject(document.getElementById('ensure-your-success'));
    // var team_makeup = visibilityObject(document.getElementById('team-makeup'));
    var assess_the_opportunity = visibilityObject(document.getElementById('assess-the-opportunity'), true, 40);
    // var process_list = visibilityObject(document.getElementById('process-list'));
    // var process_list = document.getElementById('process-list');

    var sectionList = [
      ensure_your_succcess,
      // team_makeup,
      assess_the_opportunity,
      // process_list
      visibilityObject(document.getElementById('assess-the-opportunity-step')),
      visibilityObject(document.getElementById('identify-data')),
      visibilityObject(document.getElementById('walk-the-shop-floor')),
      visibilityObject(document.getElementById('do-the-math')),
      visibilityObject(document.getElementById('build-and-integrate')),
      visibilityObject(document.getElementById('drive-adoption')),
      visibilityObject(document.getElementById('secure-your-investment')),
      visibilityObject(document.getElementById('deploy-and-sustain')),
    ];
    assignActiveElementNew(sectionList);

    changeSlideInClass();

  }

  resizeLine = () => {
    const rem = 15.1;
    var processList = document.getElementById('process-list');
    var line = document.getElementById('line');
    var firstSection = document.getElementById('assess-the-opportunity');
    var lastSection = document.getElementById('deploy-and-sustain');

    var width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;

    // console.log(lastSection.offsetHeight);

    var offsetHeightSubtract = 20;

    if (width < 491) {
      offsetHeightSubtract = 100;
    }

    if (width >= 491 && width <= 991) {
      offsetHeightSubtract = 5;
    }

    var offset = 0;
    if (firstSection) {
      offset += (firstSection.offsetHeight / 4);
    }
    if (lastSection) {
      offset += lastSection.offsetHeight - offsetHeightSubtract;
    }

    if (processList && line) {
      var processListHeight = processList.offsetHeight;
      var height = (processListHeight - offset) / rem;
      line.style.height = height + 'rem';
    }


  }

  render() {
    return(  
      <Layout headerBrand={"BLD.AI"} layoutClassName="process-page">
        <div className="side-dots-nav">
          <ul className="nav-items">
            <li className="nav-item">
              <Link
                  activeClass="active"
                  to="ensure-your-success"
                  spy={true}
                  smooth={true}
                  offset={-70}
                  duration= {500}
                  className="dot-link"
              >
                <FontAwesomeIcon icon={faCircle} className="solidCircle"/>
                <FontAwesomeIcon icon={farCircle} className="regularCircle"/>
              </Link>
            </li>
            {/* <li className="nav-item">
              <Link
                  activeClass="active"
                  to="hands-on-role"
                  spy={true}
                  smooth={true}
                  offset={-70}
                  duration= {500}
                  className="dot-link"
              >
                <FontAwesomeIcon icon={faCircle} className="solidCircle"/>
                <FontAwesomeIcon icon={farCircle} className="regularCircle"/>
              </Link>
            </li> */}
            {/* <li className="nav-item">
              <Link
                  activeClass="active"
                  to="team-makeup"
                  spy={true}
                  smooth={true}
                  offset={-70}
                  duration= {500}
                  className="dot-link"
              >
                <FontAwesomeIcon icon={faCircle} className="solidCircle"/>
                <FontAwesomeIcon icon={farCircle} className="regularCircle"/>
              </Link>
            </li> */}
            <li className="nav-item">
              <Link
                  activeClass="active"
                  to="assess-the-opportunity"
                  spy={true}
                  smooth={true}
                  offset={-200}
                  duration= {500}
                  className="dot-link"
              >
                <FontAwesomeIcon icon={faCircle} className="solidCircle"/>
                <FontAwesomeIcon icon={farCircle} className="regularCircle"/>
              </Link>
            </li>
            <li className="nav-item">
              <Link
                  activeClass="active"
                  to="identify-data"
                  spy={true}
                  smooth={true}
                  offset={-70}
                  duration= {500}
                  className="dot-link"
              >
                <FontAwesomeIcon icon={faCircle} className="solidCircle"/>
                <FontAwesomeIcon icon={farCircle} className="regularCircle"/>
              </Link>
            </li>
            <li className="nav-item">
              <Link
                  activeClass="active"
                  to="walk-the-shop-floor"
                  spy={true}
                  smooth={true}
                  offset={-70}
                  duration= {500}
                  className="dot-link"
              >
                <FontAwesomeIcon icon={faCircle} className="solidCircle"/>
                <FontAwesomeIcon icon={farCircle} className="regularCircle"/>
              </Link>
            </li>
            <li className="nav-item">
              <Link
                  activeClass="active"
                  to="do-the-math"
                  spy={true}
                  smooth={true}
                  offset={-70}
                  duration= {500}
                  className="dot-link"
              >
                <FontAwesomeIcon icon={faCircle} className="solidCircle"/>
                <FontAwesomeIcon icon={farCircle} className="regularCircle"/>
              </Link>
            </li>
            <li className="nav-item">
              <Link
                  activeClass="active"
                  to="build-and-integrate"
                  spy={true}
                  smooth={true}
                  offset={-70}
                  duration= {500}
                  className="dot-link"
              >
                <FontAwesomeIcon icon={faCircle} className="solidCircle"/>
                <FontAwesomeIcon icon={farCircle} className="regularCircle"/>
              </Link>
            </li>
            <li className="nav-item">
              <Link
                  activeClass="active"
                  to="drive-adoption"
                  spy={true}
                  smooth={true}
                  offset={this.state.drive_adoption}
                  duration={500}
                  className="dot-link"
              >
                <FontAwesomeIcon icon={faCircle} className="solidCircle"/>
                <FontAwesomeIcon icon={farCircle} className="regularCircle"/>
              </Link>
            </li>
            <li className="nav-item hide-on-smaller-screens2">
              <Link
                  activeClass="active"
                  to="secure-your-investment"
                  spy={true}
                  smooth={true}
                  offset={this.state.secure_your_investment_offset}
                  duration= {500}
                  className="dot-link"
              >
                <FontAwesomeIcon icon={faCircle} className="solidCircle"/>
                <FontAwesomeIcon icon={farCircle} className="regularCircle"/>
              </Link>
            </li>
            <li className="nav-item hide-on-smaller-screens">
              <Link
                  activeClass="active"
                  to="deploy-and-sustain"
                  spy={true}
                  smooth={true}
                  offset={-70}
                  duration= {500}
                  className="dot-link"
              >
                <FontAwesomeIcon icon={faCircle} className="solidCircle"/>
                <FontAwesomeIcon icon={farCircle} className="regularCircle"/>
              </Link>
            </li>
          </ul>
        </div>
        <Container className="full-container">
          <section id="ensure-your-success" className="section process-heading full first">
            {/* <p className="heading">We take a very hands-on role in solving critical business problems.</p> */}
            <Row>
              <Col sm="12" lg="6" className="process-heading-img-holder">
                <img src={processPageHeader} alt="check" className="" />
              </Col>
              <Col sm="12" lg="6" className="process-heading-caption-column">
                <Row className="process-heading-caption">
                  <Col sm="12" className="process-heading-header">
                    <p className="header-right first-sentence">Your AI journey is distinct.</p>
                    <p className="header-right">We follow proven processes to ensure organization buy-in and quick deployment.</p>
                  </Col>
                </Row>
              </Col>
            </Row>
          </section>
        </Container>
        <Container className="full-container">
          <Animated animationIn="slideInUp" animationOut="slideOutDown" isVisible={true}>
            <p id="assess-the-opportunity" className="process-list-heading sectionDiv">
              {/* Your AI journey is distinct, and we follow proven processes to ensure organization buy-in and quick deployment. */}
            </p>
          </Animated>
          <Animated animationIn="slideInUp" animationOut="slideOutDown" isVisible={true}>
            <div id="process-list" className="">
              <div id="line"></div>
              <Animated animationIn="slideInUp" animationOut="slideOutDown" isVisible={true} animationInDelay={this.state.animationInDelayValue}>
                <section className="section process" id="assess-the-opportunity-step">
                  <Row>
                    <Col md={3} xs={12} className="process-image first">
                      <div className="image">
                        <img src={opportunity} alt="Assess the opportunity" />
                      </div>
                    </Col>
                    <Col md={9} xs={12} className="content first">
                      <p className="heading">Assess the opportunity.</p>
                      <p className="subheading">We start by understanding your industry and business goals. With this insight, our team works hand-in-hand with your team to identify the opportunity, prioritize features, estimate returns on investment, and leverage insights from senior leadership.</p>
                    </Col>
                  </Row>
                </section>
              </Animated>
              <Animated animationIn="slideInUp" animationOut="slideOutDown" isVisible={true} animationInDelay={this.state.animationInDelayValue}>
                <section id="identify-data" className="section process">
                  <Row>
                    <Col md={3} xs={12} className="process-image">
                      <div className="image">
                        <img src={data} alt="Identify the relevant data" />
                      </div>
                    </Col>
                    <Col md={9} xs={12} className="content">
                      <p className="heading">Identify the relevant data.</p>
                      <p className="subheading">The strength of your data determines the success of your AI product. We begin with a data maturity assessment to understand the type, amount, age, and frequency of available data. This process identifies what additional data gathering tools are required to maximize your product’s impact.</p>
                    </Col>
                  </Row>
                </section>
              </Animated>
              <Animated animationIn="slideInUp" animationOut="slideOutDown" isVisible={true} animationInDelay={this.state.animationInDelayValue}>
                <section id="walk-the-shop-floor" className="section process">
                  <Row>
                    <Col md={3} xs={12} className="process-image">
                      <div className="image">
                        <img src={walk} alt="Walk the shop floor" />
                      </div>
                    </Col>
                    <Col md={9} xs={12} className="content">
                      <p className="heading">Walk the shop floor.</p>
                      <p className="subheading">Understanding end users and eliminating pain points is critical to ensure adoption. We create detailed user stories to fully understand end users and create a vision for how AI enabled products will improve their work. Together we quickly design low-fidelity prototypes to ensure a functional, intuitive, and useful UI/UX they are excited to use.</p>
                    </Col>
                  </Row>
                </section>
              </Animated>
              <Animated animationIn="slideInUp" animationOut="slideOutDown" isVisible={true} animationInDelay={this.state.animationInDelayValue}>
                <section id="do-the-math" className="section process">
                  <Row>
                    <Col md={3} xs={12} className="process-image">
                      <div className="image">
                        <img src={math} alt="Do the math" />
                      </div>
                    </Col>
                    <Col md={9} xs={12} className="content">
                      <p className="heading">Do the math.</p>
                      <p className="subheading">We employ professors from top universities and experienced data scientists to create the best algorithms given the data infrastructure available. We are experts both in machine learning (e.g., predictions, recommendations, and explorations) and foundational techniques such as operations research and optimization.</p>
                    </Col>
                  </Row>
                </section>
              </Animated>
              <Animated animationIn="slideInUp" animationOut="slideOutDown" isVisible={true} animationInDelay={this.state.animationInDelayValue}>
                <section id="build-and-integrate" className="section process">
                  <Row>
                    <Col md={3} xs={12} className="process-image">
                      <div className="image">
                        <img src={build} alt="Build your product" />
                      </div>
                    </Col>
                    <Col md={9} xs={12} className="content">
                      <p className="heading">Build your product.</p>
                      <p className="subheading">Our developers build bespoke AI products for you on free and open source libraries which are often years ahead of legacy tools. Additionally, you have full control over feature prioritization and are no longer bound by off the shelf software constraints. We work in sprints to drive speed and push finished products for immediate feedback and continuous improvement.</p>
                    </Col>
                  </Row>
                </section>
              </Animated>
              <Animated animationIn="slideInUp" animationOut="slideOutDown" isVisible={true} animationInDelay={this.state.animationInDelayValue}>
                <section id="drive-adoption" className="section process">
                  <Row>
                    <Col md={3} xs={12} className="process-image">
                      <div className="image">
                        <img src={adoption} alt="Drive adoption" />
                      </div>
                    </Col>
                    <Col md={9} xs={12} className="content">
                      <p className="heading">Drive adoption.</p>
                      <p className="subheading">Together we create training materials including written documentation, in app feature walk throughs, video tutorials, and detailed FAQ to drive adoption. During deployment, we fix bugs in hours and improve the user experience the next day. We track adoption metrics and conduct user interviews to understand pain points and identify new features. </p>
                    </Col>
                  </Row>
                </section>
              </Animated>
              <Animated animationIn="slideInUp" animationOut="slideOutDown" isVisible={true} animationInDelay={this.state.animationInDelayValue}>
                <section id="secure-your-investment" className="section process">
                  <Row>
                    <Col md={3} xs={12} className="process-image">
                      <div className="image">
                        <img src={secure} alt="Secure your investment" />
                      </div>
                    </Col>
                    <Col md={9} xs={12} className="content">
                      <p className="heading">Secure your investment.</p>
                      <p className="subheading">We take data security seriously and assume threats come from anywhere at anytime. Data security is achieved through a clear cyber security policy, an understanding of threat models, and high test coverage in our DevOps pipeline.  We design mechanisms where everything is versioned and time stamped, and every merge request is signed off as a team to reduce risk.</p>
                    </Col>
                  </Row>
                </section>
              </Animated>
              <Animated animationIn="slideInUp" animationOut="slideOutDown" isVisible={true} animationInDelay={this.state.animationInDelayValue}>
                <section id="deploy-and-sustain" className="section process deploy-and-sustain">
                  <Row>
                    <Col md={3} xs={12} className="process-image last-process">
                      <div className="image">
                        <img src={deploy} alt="Deploy, maintain and improve" />
                      </div>
                    </Col>
                    <Col md={9} xs={12} className="content last-process">
                      <p className="heading">Deploy, maintain and improve.</p>
                      <p className="subheading">We continuously monitor and improve the performance of your AI through data pipeline maintenance, edge case testing, and applying Machine Learning techniques, such as active learning. There will be feature improvement requests from internal users and customers. We work together to identify opportunities and prioritize work to drive user adoption.</p>
                    </Col>
                  </Row>
                </section>
              </Animated>
            </div>
          </Animated>
        </Container>
      </Layout>
    );
  }
}

export default (Process);